(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const checkTLD = (tld) => {
        // Get the current domain
        const domain = window.location.hostname;
        return domain.endsWith(tld)    
    }

    const hideElementsBasedOnTLD = (tld, elements) => {
      // Check top level domain. EG: .com, .at
        console.log(checkTLD(tld), tld)
        if (checkTLD(tld) && elements) {
           elements.forEach((element) => {
             if (element) {
               element.remove()
             }
          })
        }
    }

    // First item is desktop menu item
    // Second item is mobile menu item
    const menuItemsToHide = [
       document.querySelector('#navigation-drawer-1 > div > div:nth-child(1) > div > div.panel__scroller.v-stack.gap-8 > ul > li:nth-child(3)'),
       document.querySelector("#header-sidebar-menu > div > div.panel.gap-8 > div > ul > li:nth-child(4)")
    ]

    console.log(menuItemsToHide)

    const elementsWithHideAttr = document.querySelectorAll("[hide='true']")

    hideElementsBasedOnTLD(".com", menuItemsToHide)
    hideElementsBasedOnTLD(".com", elementsWithHideAttr)
    

  })
})()